import {colors, sizes} from "patient-ping-remedy/packages/theme";
import styled from '@emotion/styled';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: ${sizes.small};
  flex: 1;
  margin-bottom: ${sizes.medium};
`;

export const FormWrapper = styled.div`
  .sd-body {
    padding: ${sizes.medium} 0;
  }
    
  .sd-action-bar {
    display: none;
  }
`;

export const BannerWrapper = styled.div`
  margin-top: ${sizes.medium};
  padding: ${sizes.small};
  background-color: ${colors.ash};
`;

export const PreferenceWrapper = styled.div`
  display: flex;
  gap: ${sizes.small};
  margin-top: ${sizes.medium};
`;

export const PreferenceItem = styled.div`
  flex: 1;
`;

export const PreferenceLabel = styled.div`
  font-size: 1.4rem;
  font-weight: 400;
  color: ${colors.gray5};
  padding-bottom: ${sizes.xxSmall};  
`;

export const TableWrapper = styled.div`
  margin-top: ${sizes.medium};
`;

export const SkippedMessage = styled.div`
  padding: ${sizes.small} 0;
  color: ${colors.gray5};
  font-style: italic;
`;
